import {DocumentItemKeyData} from './document-itemkey.model';
import { DocumentRequirementModel } from './document-requirement.model';

export class DocumentData {
    public documentId: number;
    public documentDescription: string;
    public documentFilename: string;
    public documentContent: any;
    public objectURL: any;
    public documentReviewStatusTypeId: string;
    public documentSignatureStatusTypeId: number;
    public documentRequirements: DocumentRequirementModel[];
    public documentItemKeys: DocumentItemKeyData[];
    public documentMimeTypeValue: string;
    public documentTypes: string[];
    public documentCategoryTypes: string;
    public documentSignatureNotificationComment: string;
    public loading: boolean;
    public objectURI: any;
}
